import { readonly, ref } from 'vue'

const showNumberFormatModal = ref<boolean>(false)
const showTransactionModal = ref<boolean>(false)
const showRadarTransactionModal = ref<boolean>(false)
const showDailyUpChallengeModal = ref<boolean>(false)
const showPathwayChallengeModal = ref<boolean>(false)
const showPuzzleChallengeModal = ref<boolean>(false)
const showPresaleModal = ref<boolean>(false)

export const useModals = () => {

  function setShowNumberFormatModal(value: boolean) {
    showNumberFormatModal.value = value
  }

  function setShowTransactionModal(value: boolean) {
    showTransactionModal.value = value
  }

  function setShowRadarTransactionModal(value: boolean) {
    showRadarTransactionModal.value = value
  }

  function setShowDailyUpChallengeModal(value: boolean) {
    showDailyUpChallengeModal.value = value
  }

  function setShowPathwayChallengeModal(value: boolean) {
    showPathwayChallengeModal.value = value
  }

  function setShowPuzzleChallengeModal(value: boolean) {
    showPuzzleChallengeModal.value = value
  }

  function setShowPresaleModal(value: boolean) {
    showPresaleModal.value = value
  }

  return {
    showNumberFormatModal: readonly(showNumberFormatModal),
    showTransactionModal: readonly(showTransactionModal),
    showRadarTransactionModal: readonly(showRadarTransactionModal),
    showDailyUpChallengeModal: readonly(showDailyUpChallengeModal),
    showPathwayChallengeModal: readonly(showPathwayChallengeModal),
    showPuzzleChallengeModal: readonly(showPuzzleChallengeModal),
    setShowNumberFormatModal,
    setShowTransactionModal,
    setShowRadarTransactionModal,
    setShowDailyUpChallengeModal,
    setShowPathwayChallengeModal,
    setShowPuzzleChallengeModal,
    showPresaleModal: readonly(showPresaleModal),
    setShowPresaleModal,
  }
}